/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap any slot to pin a driver or constructor — pinned picks filter the rankings below.`)
};

const es_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca cualquier espacio para fijar un piloto o constructor — los fijados filtran el ranking de abajo.`)
};

const de_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe auf einen Slot, um einen Fahrer oder Konstrukteur festzuheften — angeheftete Auswahlen filtern die Rangliste unten.`)
};

const nl_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik op een slot om een coureur of constructeur vast te pinnen — vastgepinde keuzes filteren de ranglijst hieronder.`)
};

const fr_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touchez un emplacement pour épingler un pilote ou un constructeur — les choix épinglés filtrent le classement ci-dessous.`)
};

const it_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca uno slot per fissare un pilota o costruttore — le scelte fissate filtrano la classifica sotto.`)
};

const pt_br2_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque em qualquer slot para fixar um piloto ou construtor — escolhas fixadas filtram os rankings abaixo.`)
};

const pt_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque em qualquer slot para fixar um piloto ou construtor — escolhas fixadas filtram as classificações abaixo.`)
};

const ja_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スロットをタップしてドライバーやコンストラクターをピン留め — ピン留めしたピックで下のランキングをフィルタリング。`)
};

const zh_f1_team_selector_pin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击任意槽位锁定车手或车队 — 锁定的选择会过滤下方排名。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_team_selector_pin_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_team_selector_pin_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_team_selector_pin_hint", locale)
	if (locale === "en") return en_f1_team_selector_pin_hint(inputs)
	if (locale === "es") return es_f1_team_selector_pin_hint(inputs)
	if (locale === "de") return de_f1_team_selector_pin_hint(inputs)
	if (locale === "nl") return nl_f1_team_selector_pin_hint(inputs)
	if (locale === "fr") return fr_f1_team_selector_pin_hint(inputs)
	if (locale === "it") return it_f1_team_selector_pin_hint(inputs)
	if (locale === "pt-BR") return pt_br2_f1_team_selector_pin_hint(inputs)
	if (locale === "pt") return pt_f1_team_selector_pin_hint(inputs)
	if (locale === "ja") return ja_f1_team_selector_pin_hint(inputs)
	return zh_f1_team_selector_pin_hint(inputs)
};